import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { followLabel, unfollowLabel } from '../redux/thunk/followedLabelsThunk';
import PillFace from './PillFace';

// Follow a record label — FollowArtistButton's twin (same pill and classes), keyed
// by the label's public id. label = { publicId, name, artworkUrl? }.
const FollowLabelButton = React.forwardRef(({ label, prominent = false, from = 'button' }, ref) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const followedSet = useSelector(state => state.followedLabels?.followedSet || {});
    const [pop, setPop] = useState(false);

    const publicId = label?.publicId || label?.label_public_id || null;
    const name = label?.name || label?.label_name || '';
    const isFollowed = publicId ? !!followedSet[publicId] : false;

    const handleClick = useCallback((e) => {
        e.stopPropagation();
        if (!isAuthenticated || !publicId || !name) return;
        if (isFollowed) {
            setPop(false);
            dispatch(unfollowLabel({ labelPublicId: publicId, name, artwork: label.artworkUrl || label.artwork || null, from }));
        } else {
            setPop(true);
            dispatch(followLabel({ ...label, publicId, name, from }));
        }
    }, [dispatch, isAuthenticated, isFollowed, publicId, name, label, from]);

    if (!isAuthenticated || !publicId || !name) return null;

    // A record with a star — the label version of the person + star follow glyph.
    const icon = (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="10" cy="12" r="8" fill={isFollowed ? 'currentColor' : 'none'} />
            <circle cx="10" cy="12" r="2" fill="none" stroke={isFollowed ? 'var(--color-bg-primary)' : 'currentColor'} />
            <polygon points="19 1.5 20.3 4.2 23.2 4.6 21.1 6.6 21.6 9.5 19 8.1 16.4 9.5 16.9 6.6 14.8 4.6 17.7 4.2" fill={isFollowed ? 'currentColor' : 'none'} strokeWidth="1.5" />
        </svg>
    );

    return (
        <button
            ref={ref}
            className={`follow-artist-btn follow-label-btn${prominent ? ' prominent' : ''}${isFollowed ? ' following' : ''}${pop ? ' pop' : ''}`}
            title={isFollowed ? 'Following — this label feeds your For You' : 'Follow — get this label’s tracks in your For You'}
            onClick={handleClick}
            onAnimationEnd={(e) => { if (e.animationName === 'pill-pop') setPop(false); }}
        >
            {prominent ? <PillFace icon={icon} label={isFollowed ? 'Following' : 'Follow'} longest="Following" /> : icon}
        </button>
    );
});

export default FollowLabelButton;
